var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThinkingMan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M168.49 429.2C168.13 428.68 167.73 428.19 167.29 427.74C167.56 421.55 168.95 390.57 171.45 334.81L150.25 337.19C150.99 391.73 151.4 422.03 151.49 428.09C147.52 432.54 147.92 439.36 152.37 443.32C156.1 446.64 161.61 446.97 165.71 444.12C170.6 440.77 171.84 434.09 168.49 429.2Z",
    id: "bAkJnPGM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.44 603.55L228.36 558.03L212.55 554.9L204.37 601.43L204.37 601.43L216.44 603.55Z",
    id: "b2wtPf0gy0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.82 612.18L202.39 597.53C216.35 599.99 224.11 601.35 225.66 601.62C233.75 603.05 239.15 610.76 237.73 618.85C237.73 618.85 237.73 618.85 237.73 618.85L199.82 612.18Z",
    id: "eBDnsyeBm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.51 607.47L189.34 560.23L171.26 560.23L171.26 607.47L171.26 607.47L183.51 607.47Z",
    id: "ai3YCsm70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.64 618.85L168.64 603.97C182.81 603.97 190.68 603.97 192.26 603.97C200.47 603.97 207.13 610.63 207.13 618.85C207.13 618.85 207.13 618.85 207.13 618.85L168.64 618.85Z",
    id: "f3LMhv9fDZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.79 594.5C221.35 594.38 209.82 593.43 208.38 593.32C205.7 593 203.79 590.58 204.1 587.9C204.11 587.82 204.12 587.74 204.14 587.66C205.03 582.69 209.46 557.82 217.45 513.05C212.05 484.59 209.05 468.78 208.46 465.62C208.29 464.74 207.44 464.16 206.55 464.33C205.84 464.46 205.3 465.06 205.24 465.78C204.11 478.43 195.12 579.64 193.99 592.29C193.74 594.93 191.44 596.89 188.79 596.72C187.43 596.67 176.57 596.27 175.21 596.22C172.74 596.04 170.8 594.06 170.68 591.59C170.61 581.48 170.31 530.94 169.76 439.96L240.18 431.16L245.1 507.13L245.08 507.21C234.89 557.37 229.23 585.24 228.1 590.81C227.57 592.99 225.61 594.53 223.37 594.54C223.17 594.54 222.98 594.52 222.79 594.5Z",
    id: "gh1XX2qXV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.98 225.51C179.43 225.51 168.44 236.5 168.44 250.05C168.44 263.6 179.43 274.59 192.98 274.59C206.53 274.59 217.52 263.6 217.52 250.05C217.52 236.5 206.53 225.51 192.98 225.51Z",
    id: "a1xgytzJwU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.25 447.94C193.37 440.52 179.87 443.47 172.88 445.89C171.47 446.38 169.92 446.2 168.66 445.41C167.41 444.63 166.6 443.32 166.44 441.86C165.17 430.51 155 339.69 153.73 328.34C151.6 309.32 163.05 291.44 180.97 285.82C180.97 285.82 180.97 285.82 180.97 285.82C181.98 285.5 182.82 285.28 183.02 285.22C194.31 282.16 206.37 284.25 215.96 290.94C225.74 297.7 232.02 308.43 233.11 320.26C234.18 331.69 242.74 423.12 243.81 434.54C243.96 436.04 243.4 437.53 242.29 438.55C238.54 442.02 227.65 451.05 216.1 451.05C212.26 451.07 208.5 449.99 205.25 447.94Z",
    id: "hoHQgKPxg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.72 349.53C145.58 349.19 143.32 346.36 143.66 343.23C143.69 342.95 143.75 342.68 143.82 342.4C144.55 339.62 150.39 317.37 151.12 314.58C152.12 305.88 159.99 299.64 168.7 300.65C177.37 301.65 183.6 309.47 182.64 318.14C182.75 321.01 183.62 343.93 183.73 346.79C183.84 349.94 181.38 352.6 178.23 352.71C177.95 352.73 177.67 352.71 177.39 352.68C177.39 352.68 151.58 349.85 148.72 349.53Z",
    id: "a1iPXwYHm4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.66 425C244.25 424.52 243.79 424.09 243.29 423.69C242.82 417.51 240.47 386.59 236.23 330.94L215.46 335.61C222.77 389.81 226.84 419.92 227.65 425.94C224.25 430.84 225.47 437.56 230.37 440.96C234.47 443.8 239.98 443.46 243.7 440.14C248.15 436.23 248.58 429.45 244.66 425Z",
    id: "hoPmSddpC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.68 342.46C205.79 339.59 206.65 316.67 206.76 313.81C205.8 305.1 212.09 297.26 220.79 296.3C229.47 295.35 237.29 301.58 238.29 310.25C239.02 313.03 244.86 335.29 245.59 338.07C246.39 341.12 244.56 344.24 241.51 345.04C241.24 345.12 240.97 345.17 240.69 345.2C237.82 345.51 214.88 348.03 212.01 348.35C210.36 348.53 208.71 347.99 207.5 346.85C206.28 345.72 205.62 344.12 205.68 342.46Z",
    id: "a2wkAmKRRI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.22 275.36C190.21 275.36 190.11 275.34 190.1 275.33C168.52 272.03 163.76 259.54 162.71 254.32C161.63 248.92 162.86 243.7 165.65 241.67C164.13 236.88 164.37 232.62 166.37 229.02C169.87 222.75 177.44 220.63 178.46 220.37C184.51 215.9 191.75 218.88 193.07 219.49C204.78 215.16 209.25 218.76 210.06 219.57C215.3 220.51 218.49 222.53 219.55 225.58C221.54 231.3 215.24 238.43 214.98 238.73C214.97 238.74 214.92 238.79 214.84 238.88C209.21 239.15 206.09 239.3 205.47 239.33C201.96 239.5 199.26 242.47 199.42 245.98C199.43 246.2 199.46 246.42 199.49 246.64C199.49 246.64 199.49 246.64 199.49 246.64C199.74 247.77 200.06 248.89 200.45 249.99C202.05 254.99 203.25 259.26 201.7 260.89C200.99 261.53 199.97 261.71 199.08 261.34C197.61 260.95 196.62 261.03 196.12 261.59C195.35 262.45 195.59 264.62 196.79 267.71C197.55 269.7 197.15 271.95 195.74 273.55C194.69 274.79 193.15 275.51 191.52 275.52C191.08 275.51 190.65 275.46 190.22 275.36Z",
    id: "d1viBVBnzB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 619.71C0.45 619.71 0 619.26 0 618.71C0 618.16 0.45 617.71 1 617.71C39.06 617.71 343.58 617.71 381.64 617.71C382.19 617.71 382.64 618.16 382.64 618.71C382.64 619.26 382.19 619.71 381.64 619.71C305.51 619.71 39.06 619.71 1 619.71Z",
    id: "c16Ijd5AYs"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bAkJnPGM",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bAkJnPGM",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2wtPf0gy0",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2wtPf0gy0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eBDnsyeBm",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eBDnsyeBm",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ai3YCsm70",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ai3YCsm70",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f3LMhv9fDZ",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f3LMhv9fDZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gh1XX2qXV",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gh1XX2qXV",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1xgytzJwU",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1xgytzJwU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hoHQgKPxg",
    opacity: 1,
    fill: "#4e44dc",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hoHQgKPxg",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1iPXwYHm4",
    opacity: 1,
    fill: "#4e44dc",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1iPXwYHm4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hoPmSddpC",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hoPmSddpC",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2wkAmKRRI",
    opacity: 1,
    fill: "#4e44dc",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2wkAmKRRI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1viBVBnzB",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1viBVBnzB",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c16Ijd5AYs",
    opacity: 1,
    fill: "#3f3d56",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c16Ijd5AYs",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkingMan);
export default __webpack_public_path__ + "static/media/thinking_man.a22a7a1b64397f4d4336bf3182b45182.svg";
export { ForwardRef as ReactComponent };